export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.44f2d7f17d13218f36a2.worker.js");
}
